import { useState } from 'react';

const useFileToBase64 = () => {
  const [base64Images, setBase64Images] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const convertToBase64 = (files) => {
    setLoading(true);
    setError(null);

    const fileArray = Array.from(files);
    const promises = fileArray.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = (e) => {
          resolve({
            data: e.target.result,
            name: file.name,
            type: file.type,
            size: file.size
          });
        };
        
        reader.onerror = (error) => {
          reject(error);
        };
        
        reader.readAsDataURL(file);
      });
    });

    Promise.all(promises)
      .then((results) => {
        setBase64Images(prev => [...prev, ...results]);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  const removeImage = (index) => {
    setBase64Images(prev => prev.filter((_, i) => i !== index));
  };

  const clearAll = () => {
    setBase64Images([]);
    setError(null);
  };

  return {
    base64Images,
    loading,
    error,
    convertToBase64,
    removeImage,
    clearAll
  };
};

export default useFileToBase64;
